import Store from "App/Store.js";

export default featuresForced => Store.dispatch({type: "featuresForced", featuresForced});
